import type {PlatformClient} from '../../../platform/supabase';
import {parsePolicyLibrary,POLICY_PAGE_SIZE,type PolicyLoader} from './policy';
/** Uses the existing signed-in API client. No service key, crawler, policy refresh, or AI call. */
export function createPolicyLoader(client:PlatformClient):PolicyLoader{
  return async request=>{
    if(request.signal.aborted)throw new DOMException('Aborted','AbortError');
    const {data,error}=await client.rpc('center_policy_library',{
      p_school_id:request.schoolId,p_academic_year_id:request.academicYearId,
      p_offset:request.offset,p_limit:POLICY_PAGE_SIZE
    }).abortSignal(request.signal);
    if(request.signal.aborted)throw new DOMException('Aborted','AbortError');
    if(error)throw error;
    return parsePolicyLibrary(data,request);
  };
}
